import { styled } from '@mui/system';
import { Box, Typography, Container, Stack } from '@mui/material';
import { fontFamilies } from '../../../../../constants/theme';
import { SectionHeading } from '../../styles';

export const SectionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: 'column',
}));

export const ContentContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const SectionTitle = styled(SectionHeading)(({ theme }) => ({
  ...theme.typography.heading,
  textAlign: 'left',
  letterSpacing: '-.2px',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
  },
}));

export const CardsStack = styled(Stack)(({ theme }) => ({
  gap: '20px',
  marginTop: '49px',
  [theme.breakpoints.down('md')]: {
    gap: '16px',
    marginTop: '32px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '12px',
    marginTop: '24px',
  },
}));

export const BottomText = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  fontSize: '22px',
  lineHeight: '32px',
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  whiteSpace: 'pre-line',
  marginTop: '50px',
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
    lineHeight: '28px',
    marginTop: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: '32px',
  },
}));

export const ButtonStack = styled(Stack)(({ theme }) => ({
  justifyContent: 'center',
  marginTop: '50px',
  [theme.breakpoints.down('md')]: {
    marginTop: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '30px',
  },
}));
